import { render, staticRenderFns } from "./ProductServiceYxzt.vue?vue&type=template&id=c8250572&scoped=true&"
import script from "./ProductServiceYxzt.vue?vue&type=script&lang=js&"
export * from "./ProductServiceYxzt.vue?vue&type=script&lang=js&"
import style0 from "./ProductServiceYxzt.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProductServiceYxzt.vue?vue&type=style&index=1&id=c8250572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8250572",
  null
  
)

export default component.exports